module.exports = __webpack_public_path__ + "assets/images/quote-right-black.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/quote-right-black.png
 ** module id = 27
 ** module chunks = 0
 **/